import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { adminLogin, adminMe } from '../../lib/api';
import { Home } from 'lucide-react';
import toast from 'react-hot-toast';

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const check = async () => {
      try { await adminMe(); navigate('/admin/dashboard', { replace: true }); } catch(e) {}
    };
    check();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      // Store token in localStorage as fallback for cookie issues
      if (res.data?.token) {
        localStorage.setItem('motoveloz-admin-token', res.data.token);
      }
      toast.success('Login realizado!');
      navigate('/admin/dashboard');
    } catch (err) {
      toast.error('Credenciais inválidas');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090B]">
      <div className="max-w-md w-full px-4">
        <div className="bg-zinc-900 border border-zinc-800 p-8">
          <div className="text-center mb-8">
            <img src="/logo.png" alt="MotoVeloz" className="w-16 h-16 mx-auto mb-3 object-contain" />
            <h1 className="text-2xl font-bold text-white uppercase tracking-tight" style={{ fontFamily: 'Teko, sans-serif' }} data-testid="admin-login-title">Painel Admin</h1>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-zinc-400 text-xs font-bold uppercase tracking-wider mb-2">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="w-full px-4 py-3 bg-zinc-800 border border-zinc-700 text-white focus:outline-none focus:border-red-500 text-sm" data-testid="admin-email-input" />
            </div>
            <div>
              <label className="block text-zinc-400 text-xs font-bold uppercase tracking-wider mb-2">Senha</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                className="w-full px-4 py-3 bg-zinc-800 border border-zinc-700 text-white focus:outline-none focus:border-red-500 text-sm" data-testid="admin-password-input" />
            </div>
            <button type="submit" disabled={loading} data-testid="admin-login-btn"
              className="w-full bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white font-bold py-3 uppercase tracking-wider transition-colors">
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
          <Link to="/" data-testid="go-to-store-btn"
            className="mt-4 w-full bg-zinc-800 hover:bg-zinc-700 text-white font-bold py-3 uppercase tracking-wider transition-colors flex items-center justify-center gap-2 text-sm">
            <Home className="h-4 w-4" /> Ir para a Loja
          </Link>
        </div>
      </div>
    </div>
  );
}
